import { Container } from 'unstated';
import { isEmpty, isNumeric } from 'validator';

import { validateEmptyValue } from '../../../helpers/Validations/validateEmptyValue';

export interface IVoucherDetailState {
  voucher: GQL.IVoucher;
  errors: IValidationErrors;
}

export interface IVoucherDetailStateProps {
  voucher: GQL.IVoucher;
}

export interface IValidationErrors {
  title: string | undefined;
  active: string | undefined;
  usageLimit: string | undefined;
}

export class StateContainer extends Container<IVoucherDetailState> {
  
  constructor(props: IVoucherDetailStateProps) {
    super();

    const voucher = props.voucher && props.voucher.id ? props.voucher : ({} as any);

    this.state = {
      voucher: voucher,
      errors: {} as IValidationErrors
    };

    this.preValidate();
  }

  public async onChange(key: string, val: any, callback?: () => void) {
    const voucher = { ...this.state.voucher };

    await this.setState({ voucher: { ...voucher, [key]: val } });

    await this.validateField(key);

    if (callback) {
      callback();
    }
  }

  public async preValidate() { }

  public async validate(): Promise<IValidationErrors> {
    const { voucher } = this.state;
    const errors = { ...this.state.errors };

    const message = 'This field is required';

    const validateEmpty = (input: string) => {
      if (input == undefined || isEmpty(input)) {
        return message;
      } else {
        return undefined;
      }
    };

    const validateNumeric = (input: string | number) => {
      if (input == undefined || !isNumeric('' + input)) {
        if (input == '0') {
          return undefined;
        }
        return message;
      }

      return undefined;
    };

    errors.title = validateEmpty(voucher.title || '');
    errors.usageLimit = validateNumeric(voucher.usageLimit);

    await this.setState({ errors });
    return errors;
  }

  private async validateField(fieldName: string) {
    const { voucher } = this.state;

    if(fieldName != 'pohodaIDS') {
      const message = validateEmptyValue(voucher[fieldName], true);
      return await this.setState({
        errors: { ...this.state.errors, [fieldName]: message }
      });
    }
  }

  public async getVoucher() {
    return { ...this.state.voucher };
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Vouchers/VoucherDetail/StateContainer.ts